<template>
  <div class="ma-4 px-4">
    <searchBar :addField="false" @updateSearch="(v) => (search = v)" />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="StudentElectiveCourseHeaders"
            :search="search"
            :items="items"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                class="mr-2"
                color="accent"
                @click="navigateToStudentElectives(item)"
              >
                mdi-dots-horizontal
              </v-icon>
            </template>
            <template #[`item.course_id`]="{ item }">
              {{ getCourseName(item.course_id) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar.vue";
import { StudentElectiveCourseHeaders } from "@/constants/headers";

export default {
  components: { searchBar },
  data() {
    return {
      search: "",
      StudentElectiveCourseHeaders,
      program_batches: [],
      partners: [],
      courses: [],
      partner_id: null,
      program_batch_id: null,
      items: [],
    };
  },
  created() {
    this.partner_id = this.$route.query?.partner_id;
    this.program_batch_id = this.$route.query?.program_batch_id;

    this.initialise();
  },
  methods: {
    async initialise() {
      await Promise.all([
        this.getProgramBatches(),
        this.getPartners(),
        this.getCourses(),
      ]);
      const programBatchName = this.getProgramBatchName(this.program_batch_id);
      const partner = this.getPartnerName(this.partner_id);

      if (!partner || !programBatchName) {
        this.$store.commit("showSnackbar", {
          message: "Program Batch or Partner Missing",
          color: "error",
        });
        this.$router.go(-1);
        return;
      }
      this.$store.commit("setBreadcrumbs", [
        { text: "Elective", to: { name: "Elective" } },
        { text: `${programBatchName} - ${partner}` },
      ]);
      this.getStudentElectivesCourse();
    },
    async getProgramBatches() {
      await this.$axios.get("/program_batches").then((res) => {
        this.program_batches = res.data.data;
      });
    },
    async getPartners() {
      await this.$axios.get("/partners").then((res) => {
        this.partners = res.data.data;
      });
    },
    async getCourses() {
      await this.$axios.get("/courses").then((res) => {
        this.courses = res.data.data;
      });
    },
    getProgramBatchName(id) {
      if (!id) return "";
      const programBatchName = this.program_batches.find((p) => p.id == id);
      return programBatchName ? programBatchName.name : "";
    },
    getPartnerName(id) {
      if (!id) return "";
      const partner = this.partners.find((p) => p.id == id);
      return partner ? partner.name : "";
    },
    getCourseName(id) {
      if (!id) return "";
      const course = this.courses.find((p) => p.id == id);
      return course ? course.name : "";
    },
    async getStudentElectivesCourse() {
      await this.$axios
        .get("/get_student_electives_by_course", {
          params: {
            program_batch_id: this.program_batch_id,
            partner_id: this.partner_id,
          },
        })
        .then((res) => {
          this.items = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    navigateToStudentElectives(item) {
      this.$router.push({
        path: "/student_elective_course_program",
        query: {
          program_batch_id: this.program_batch_id,
          partner_id: this.partner_id,
          course_id: item.course_id,
        },
      });
    },
    customFilter(value, search, item) {
      if (!search) return true;

      const courseName = this.getCourseName(item.course_id);

      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        courseName.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
